import React, { useState } from "react";
import { HiOutlineCurrencyRupee } from "react-icons/hi";
import { GrPersonalComputer } from "react-icons/gr";
import { Select } from "antd";
import MobileHeader from "./MobileHeader";
const Header = ({ admin_data }) => {
  const handleChange = (value) => {
    console.log(`selected ${value}`);
  };

  return (
    <>
      <div className="header_container">
        <div className="header_left">
          <div className="left_hd_container">
            <GrPersonalComputer className="icon_header" />
            <span className="header_left_name">View Website</span>
          </div>
          <div className="left_hd_container">
            <HiOutlineCurrencyRupee className="icon_header" />
            <span className="header_left_name">Billing</span>
          </div>
        </div>
        <div className="header_right">
          <div className="right_conta">
            <span className="header_right_name">{admin_data?.name}</span>
          </div>
          <Select
            defaultValue="English"
            style={{
              width: 120,
            }}
            onChange={handleChange}
            options={[
              {
                value: "English",
                label: "English",
              },
              {
                value: "Hindi",
                label: "Hindi",
              },
              {
                value: "Telugu",
                label: "Telugu",
              },
            ]}
          />

          <div className="file_logo">
            <img src="/assets/logo/logo.jpg" alt="logo" />
          </div>
        </div>
      </div>

      <MobileHeader />
    </>
  );
};

export default Header;
